module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scale"
  }, [_c('div', {
    staticClass: "scale-ruler",
    style: (("width: " + _vm.rulerWidth + "px"))
  }), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.size) + "m")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55a00d84","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/scale_ruler.vue
// module id = 916
// module chunks = 0